module.exports = __webpack_public_path__ + "img/italy-blood-diseases-female.b840db33.png";